<template>
  <v-card-actions>
    <div class="flex-grow-1"></div>
    <v-btn 
      color="primary" 
      class="white--text" 
      :disabled="disabled"
      @click="$emit('primary-button-clicked')">
      {{ primaryButtonText }}
    </v-btn>
    <v-btn 
      v-if="secondaryButtonText"
      color="secondary" 
      @click="$emit('secondary-button-clicked')">
      {{ secondaryButtonText }}
    </v-btn>
  </v-card-actions>
</template>

<script>
export default {
  props: {
    primaryButtonText: String,
    secondaryButtonText: String,
    disabled: Boolean
  }
}
</script>
